import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePillar } from '../../context/PillarContext';
import { Lock } from 'lucide-react';

export default function PillarBar() {
    const { visiblePillars, activePillarId, setActivePillar } = usePillar();
    const navigate = useNavigate();
    const location = useLocation();

    const handlePillarClick = (pillar) => {
        setActivePillar(pillar.id);
        // On the Wiki, the pillar bar switches the Wiki department in place —
        // don't navigate away (the Wiki reacts to activePillarId).
        if (location.pathname.startsWith('/wiki')) return;
        if (pillar.defaultPath && !pillar.comingSoon) {
            navigate(pillar.defaultPath);
        }
    };

    return (
        <div className="border-b border-stone-200 bg-white/80 backdrop-blur-sm">
            <div className="flex items-center overflow-x-auto scrollbar-hide">
                {visiblePillars.map((pillar) => {
                    const Icon = pillar.icon;
                    const isActive = pillar.id === activePillarId;

                    return (
                        <button
                            key={pillar.id}
                            onClick={() => handlePillarClick(pillar)}
                            className={`
                                flex items-center gap-2 px-4 py-2.5 text-sm font-medium whitespace-nowrap
                                transition-all duration-150 border-b-2 flex-shrink-0
                                ${isActive
                                    ? 'border-stone-900 text-stone-900'
                                    : 'border-transparent text-stone-500 hover:text-stone-700 hover:border-stone-300'
                                }
                                ${pillar.comingSoon ? 'opacity-60' : ''}
                            `}
                            title={pillar.comingSoon ? `${pillar.label} — Coming Soon` : pillar.label}
                        >
                            <Icon className="w-4 h-4" />
                            <span className="hidden sm:inline">{pillar.label}</span>
                            {pillar.comingSoon && (
                                <span className="hidden md:inline text-[10px] px-1.5 py-0.5 bg-stone-100 text-stone-400 rounded-full font-normal">
                                    Soon
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
